import ApiService from "@/common/api.service"

export const GraduateService = {
    importGenericEntry(params) {
        return ApiService.post("/preservice/genericEntries/import", params);
    },
    updateImportedGraduate(slug, params) {
        return ApiService.update("/preservice/genericEntries", slug, params);
    },
    importPostBasic(params) {
        return ApiService.post("/preservice/postBasic/import", params);
    },
    importPostGraduate(params) {
        return ApiService.post("/preservice/postGraduate/import", params);
    },

//
    async getPostServices(page, itemsPerPage, params) {
        const res = await ApiService.get(
            `/pre-services?page=${page}&pageSize=${itemsPerPage}${params}`
        );
        return res.data
    },
    createPreService(params) {
        return ApiService.post("pre-services/add", params);
    },
    updatePreService(slug, params) {
        return ApiService.update("/pre-services", slug, params);
    },
}